/**
 * @desc: 异常订单
 * @author: huli
 * @version: v1.0
 */

import request from '@/plugins/http'

export const getListData = params => {
  return request.get('/order/freeze/list', params)
}

// 订单释放
export const freezeOrder = params => {
  return request.get('/order/freeze/deal', params)
}




